module.exports = __webpack_public_path__ + "img/walletconnect.3edee8a4.svg";